module.exports = __webpack_public_path__ + "static/media/tao_fishermen_1940_lanyu_airport.be494577.jpg";